export default __webpack_public_path__ + "static/media/konst.f617b22e.svg";